import React from 'react'
import { FC, useEffect, useState, useMemo, useRef } from 'react'
import { FormikProps } from 'formik'
import ArrayInput from '../../../utils/form/ArrayInput'
import { propsInterfaceFormGroupInput } from '../../../utils/form/FormGroupInput'
import { callSP } from '../../../../setup/axios/AxiosCallSP'
import { warn, error } from '../../../utils/customToasd'
import { optiosContract } from '../ICreateContract'
import { quitarDuplicadoReceta } from '../../minutas/grillas/gridService'
import { setLStorage } from 'global.d'
import { iteratorSymbol } from 'immer/dist/internal'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { AlertModal } from '../../../utils/modal/AlertModal'

const StepContract1: FC<StepContract1Props> = ({ data, ...props }) => {
  const location = useLocation()
  const [daysSelected, setDaysSelected] = useState<any>(7)
  const [weeks, setWeeks] = useState<any>(null)
  const [arrayInput, setArrayInput] = useState<propsInterfaceFormGroupInput[]>([])
  const [arrayInput2, setArrayInput2] = useState<propsInterfaceFormGroupInput[]>([])
  const [readonlyCkeck, setReadonlyCkeck] = useState<boolean>(false)
  const [contratoNuevo, setContratoNuevo] = useState<boolean>(false)
  const [isHomologadaInput, setIsHomologadaInput] = useState<boolean>(false)
  const [isHomologadaInput2, setIsHomologadaInput2] = useState<boolean>(false)
  const [editData, setEditData] = useState<boolean>(true)
  const [datastate, setDatastate] = useState<any>()
  const [showEstructurasModal, setShowEstructurasModal] = useState<boolean>(false)
  const [estructurasModal, setEstructurasModal] = useState<any[]>([])
  const [estructurasSeleccionadas, setEstructurasSeleccionadas] = useState<any[]>([])
  const [contratoSeleccionadoParaModal, setContratoSeleccionadoParaModal] = useState<any>(null)
  const [dataEstructurasFijasOriginales, setDataEstructurasFijasOriginales] = useState<any[]>([]) // Guardar datos originales de estructuras fijas
  const [isLoadingContrato, setIsLoadingContrato] = useState<boolean>(false)
  const [ultimoContratoId, setUltimoContratoId] = useState<any>(null)
  const [contratosMultiplesProcesados, setContratosMultiplesProcesados] = useState<Set<any>>(new Set())
  const [contractList2, setContractList2] = useState<any[]>([]) // Estado para almacenar contratos de amd_getContratos2
  const abriendoModalRef = useRef<boolean>(false) // Ref para evitar que el modal se abra múltiples veces
  const ultimoContratoProcesadoRef = useRef<any>(null) // Ref para rastrear el último contrato que se está procesando
  const contratosMultiplesYaProcesadosRef = useRef<Set<number>>(new Set()) // Ref para rastrear contratos múltiples ya procesados
  const procesandoContratoRef = useRef<number | null>(null) // Ref para rastrear el contrato que se está procesando AHORA MISMO
  const contratoOrigenYaProcesadoRef = useRef<boolean>(false) // Ref para rastrear si el contrato origen ya fue procesado y aceptado
  const [templateOptions] = useState<any>([
    { text: 'Rotativa Normal', value: 1 },
    { text: 'Minuta Fija', value: 2 },
    { text: 'No Rotativa', value: 3 },
  ])

  const [servicios, setServicios] = useState<any[]>([])

  const { user } = useSelector(({ auth }: any) => auth)
  
  // Memorizar las opciones de contratos para evitar recalcularlas constantemente
  const optionContract = useMemo(() => {
    if (props.formikProps?.values?.homologada && data?.contractList && Array.isArray(data.contractList)) {
      return data.contractList.map((item: any) => ({
        text: `${item.id || ''} - ${item.ceco || ''} ${item.cli_nombre || ''} ${item.reg_codigo || ''} ${item.regimen || ''} ${item.codServicio || ''} ${item.servicio || ''}`,
        value: item.id
      }))
    }
    return []
  }, [data?.contractList, props.formikProps?.values?.homologada])
  
  // Cargar contratos de amd_getContratos2 cuando cambie el contrato seleccionado en Homologada Origen
  // Cargar siempre que haya un contrato origen seleccionado para tener las opciones disponibles
  useEffect(() => {
    const loadContratos2 = async () => {
      const contratoOrigen = props.formikProps?.values?.templateHomologada
      const homologada2 = props.formikProps?.values?.homologada2
      const templateHomologada2 = props.formikProps?.values?.templateHomologada2
      
      // Cargar contratos siempre que haya un contrato origen seleccionado
      // Esto permite que el select tenga opciones disponibles cuando el usuario marque el checkbox
      if (contratoOrigen && Array.isArray(contratoOrigen) && contratoOrigen.length > 0 && contratoOrigen[0]?.value) {
        const contratoId = contratoOrigen[0].value
        try {
          const response = await callSP('amd_getContratos2', [
            { text: 'contrato', value: contratoId.toString() }
          ])
          
          // Intentar diferentes estructuras posibles de respuesta
          let contratosResult = null
          if (response?.data?.status === '200' && Array.isArray(response.data.result)) {
            contratosResult = response.data.result
          } else if (response?.data?.status === '200' && Array.isArray(response.data.data)) {
            contratosResult = response.data.data
          } else if (response?.status === '200' && Array.isArray(response.result)) {
            contratosResult = response.result
          } else if (Array.isArray(response?.data)) {
            contratosResult = response.data
          }
          
          if (contratosResult && Array.isArray(contratosResult) && contratosResult.length > 0) {
            setContractList2(contratosResult)
          } else {
            setContractList2([])
          }
        } catch (e: any) {
          setContractList2([])
        }
      } else {
        setContractList2([])
      }
    }
    
    loadContratos2()
  }, [props.formikProps?.values?.templateHomologada, props.formikProps?.values?.homologada2, props.formikProps?.values?.templateHomologada2])
  
  const optionContract2 = useMemo(() => {
    // CRÍTICO: Mostrar opciones si:
    // 1. El checkbox está marcado (usuario quiere usar contratos múltiples)
    // 2. O ya hay contratos múltiples cargados (modo edición)
    const homologada2 = props.formikProps?.values?.homologada2
    const templateHomologada2 = props.formikProps?.values?.templateHomologada2
    const hayContratosCargados = templateHomologada2 && Array.isArray(templateHomologada2) && templateHomologada2.length > 0
    
    // IMPORTANTE: Generar opciones siempre que haya contratos cargados, independientemente del checkbox
    // El checkbox solo controla si el select está habilitado, no si las opciones están disponibles
    let opciones: any[] = []
    
    // 1. Primero agregar los contratos de contractList2 (de amd_getContratos2)
    if (contractList2 && Array.isArray(contractList2) && contractList2.length > 0) {
      opciones = contractList2.map((item: any) => ({
        text: `${item.id || ''} - ${item.ceco || ''} ${item.cli_nombre || ''} ${item.reg_codigo || ''} ${item.regimen || ''} ${item.codServicio || ''} ${item.servicio || ''}`,
        value: item.id
      }))
    }
    
    // 2. CRÍTICO: En modo edición, asegurar que los contratos ya seleccionados aparezcan en las opciones
    // aunque no estén en contractList2 (pueden haber sido cargados desde id_contrato_rel2)
    if (hayContratosCargados) {
      templateHomologada2.forEach((contrato: any) => {
        const contratoId = typeof contrato === 'object' ? contrato.value : contrato
        const existeEnOpciones = opciones.some((opt: any) => opt.value === contratoId)
        
        if (!existeEnOpciones && contratoId) {
          // Agregar el contrato a las opciones
          const contratoText = typeof contrato === 'object' && contrato.text 
            ? contrato.text 
            : `Contrato ${contratoId}`
          
          opciones.push({
            text: contratoText,
            value: contratoId
          })
        }
      })
    }
    
    if (opciones.length > 0) {
      return opciones
    }
    
    return []
  }, [contractList2, props.formikProps?.values?.homologada2, props.formikProps?.values?.templateHomologada2])
  let _state: any = {}
  useEffect(() => {
    setLStorage('dataRow3', '')
    setLStorage('dataRow2', '')

    const state: any = location.state
    if (state?.params) {
      const contract = {
        ...state?.params,
        id: state?.contrato,
      }
      setDatastate(contract)
      _state = contract
      if (contract?.plantilla > 0 || contract?.minuta > 0) {
        //setIsHomologadaInput(true)
      }
    }
  }, [])

  useEffect(() => {
    setArrayInput2([
      {
        type: 'number-checkbox',
        campo: 'quantityMonday',
        placeholder: 'Ingrese cantidad',
        campoChk: 'monday',
        label: 'Lunes',
        readonlyCheckbox: _state.plantilla > 0 ? true : false,
        onClick: (event: any, setFieldValue: any, values: any) => {
          setFieldValue('frequencyCycle', 0)
          onDaysSelected(values)
        },
      },
      {
        type: 'number-checkbox',
        placeholder: 'Ingrese cantidad',
        campo: 'quantityTuesday',
        campoChk: 'tuesday',
        readonlyCheckbox: _state.plantilla > 0 ? true : false,
        label: 'Martes',
        onClick: (event: any, setFieldValue: any, values: any) => {
          setFieldValue('frequencyCycle', 0)
          onDaysSelected(values)
        },
      },
      {
        type: 'number-checkbox',
        placeholder: 'Ingrese cantidad',
        campo: 'quantityWednesday',
        campoChk: 'wednesday',
        readonlyCheckbox: _state.plantilla > 0 ? true : false,
        label: 'Miercoles',
        onClick: (event: any, setFieldValue: any, values: any) => {
          setFieldValue('frequencyCycle', 0)
          onDaysSelected(values)
        },
      },
      {
        type: 'number-checkbox',
        placeholder: 'Ingrese cantidad',
        campo: 'quantityThursday',
        campoChk: 'thursday',
        readonlyCheckbox: _state.plantilla > 0 ? true : false,
        label: 'Jueves',
        onClick: (event: any, setFieldValue: any, values: any) => {
          setFieldValue('frequencyCycle', 0)
          onDaysSelected(values)
        },
      },
      {
        type: 'number-checkbox',
        placeholder: 'Ingrese cantidad',
        campo: 'quantityFriday',
        campoChk: 'friday',
        readonlyCheckbox: _state.plantilla > 0 ? true : false,
        label: 'Viernes',
        onClick: (event: any, setFieldValue: any, values: any) => {
          setFieldValue('frequencyCycle', 0)
          onDaysSelected(values)
        },
      },
      {
        type: 'number-checkbox',
        placeholder: 'Ingrese cantidad',
        campo: 'quantitySaturday',
        campoChk: 'saturday',
        readonlyCheckbox: _state.plantilla > 0 ? true : false,
        label: 'Sabado',
        onClick: (event: any, setFieldValue: any, values: any) => {
          setFieldValue('frequencyCycle', 0)
          onDaysSelected(values)
        },
      },
      {
        type: 'number-checkbox',
        placeholder: 'Ingrese cantidad',
        campo: 'quantitySunday',
        campoChk: 'sunday',
        readonlyCheckbox: _state.plantilla > 0 ? true : false,
        label: 'Domingo',
        onClick: (event: any, setFieldValue: any, values: any) => {
          setFieldValue('frequencyCycle', 0)
          onDaysSelected(values)
        },
      },
    ])
  }, [readonlyCkeck])

  // CRÍTICO: useEffect para escuchar cambios en templateHomologada2 y guardar en localStorage
  // Esta es la fuente de verdad - siempre guarda el valor actualizado de Formik
  // PERO solo si el checkbox está marcado Y hay valores seleccionados manualmente
  useEffect(() => {
    const templateHomologada2 = props.formikProps?.values?.templateHomologada2
    const homologada2 = props.formikProps?.values?.homologada2
    
    // CRÍTICO: Solo procesar si el checkbox está marcado EXPLÍCITAMENTE
    // Esto previene guardar valores automáticos cuando el checkbox no está marcado
    if (homologada2 === true) {
      if (templateHomologada2 && Array.isArray(templateHomologada2) && templateHomologada2.length > 0) {
        // Extraer los IDs de los contratos seleccionados
        const contratosIds = templateHomologada2.map((c: any) => {
          if (typeof c === 'object' && c !== null) {
            return c.value || c.id || c
          }
          return c
        }).filter((id: any) => id && id !== '' && id !== 0)
        
        const contratosIdsUnicos = Array.from(new Set(contratosIds))
        
        // SIEMPRE guardar el valor actualizado en localStorage
        localStorage.setItem('templateHomologada2', JSON.stringify(contratosIdsUnicos))
      } else {
        // Si no hay contratos seleccionados, limpiar localStorage
        localStorage.removeItem('templateHomologada2')
      }
    } else {
      // Si el checkbox está desmarcado (o es false/undefined), limpiar localStorage
      localStorage.removeItem('templateHomologada2')
    }
  }, [props.formikProps?.values?.templateHomologada2, props.formikProps?.values?.homologada2])

  async function name2() {
    const state: any = location.state
    if (state?.params) {
      const contract = {
        ...state?.params,
        id: state?.contrato,
      }
      _state = contract
      if (contract?.plantilla > 0 || contract?.minuta > 0) {
        //setIsHomologadaInput(true)
      }
    }
  }
  useEffect(() => {
    ; (async () => {
      await name2();
      if (props.isReady) {

        const templateType = props.formikProps?.values?.templateType
        let hideFrequencyCycle = false
        if (templateType && Array.isArray(templateType) && templateType.length > 0 && templateType[0]?.value === 3) {
          checkAll()
          setReadonlyCkeck(true)
          hideFrequencyCycle = true
          props.formikProps?.setFieldValue('weeks', 4)
          props.formikProps?.setFieldValue('frequencyCycle', 28)
        } else {
          setReadonlyCkeck(false)
        }

        const arrSitiosAux: any = (data?.sitios && Array.isArray(data.sitios)) ? data.sitios.map((sitio: any) => {
          const arrayUsuarios = (data?.usuariosSistios && Array.isArray(data.usuariosSistios))
            ? data.usuariosSistios
            .filter(({ idSitio }: any) => {
                return idSitio && sitio?.cli_codigo && idSitio.toString() === sitio.cli_codigo.toString()
            })
            .map(({ idusuario }: any) => idusuario)
            : []

          return arrayUsuarios.includes(parseInt(user?.id || user?.idUser || '0')) && sitio
        }) : []

        const arrSitios: any = Array.isArray(arrSitiosAux) ? arrSitiosAux.filter((e: any) => e) : []
        // Las opciones de contratos se calculan con useMemo fuera del useEffect para optimizar rendimiento


        // Determinar si estamos en modo edición
        // Cuando se edita, siempre se pasa location.state.contrato con el ID del contrato
        const contratoId = (location.state as any)?.contrato
        const esModoEdicion = contratoId && parseInt(contratoId) > 0
        
        setArrayInput([
          {
            columInput: 1,
            type: 'select-checkbox',
            style: { width: "100%" },
            campo: 'templateHomologada',
            placeholder: 'Placeholder Homologada',
            campoChk: 'homologada',
            label: 'Homologada Origen',
            disabled: esModoEdicion,
            readonlyCheckbox: esModoEdicion,
            onClick: (event: any, setFieldValue: any, values: any) => {
              // En modo edición, no permitir cambios
              if (esModoEdicion) return
              setIsHomologadaInput(values?.homologada)
              if (props.setIsHomologada) props.setIsHomologada(values?.homologada)
            },
            advanceOptions: {
              id: 'templateHomologada',
              placeholder: 'Seleccionar Contrato',
              multiple: false,
              options: optionContract,
            },
            className: 'form-control b-0 p-0 w-100 form-control-lg input-contract',
            onChange: async (event: any, setFieldValue: any, values: any) => {
              // CRÍTICO: En modo edición, NO abrir el modal de estructuras
              // Solo cargar los valores en el formulario
              if (props.editData && editData) {
                return
              }
              
              // Si el checkbox no está marcado pero el usuario está intentando seleccionar un contrato,
              // marcarlo automáticamente en lugar de mostrar un error
              if (!values?.homologada) {
                setFieldValue('homologada', true)
                // Esperar un momento para que Formik actualice el estado antes de continuar
                await new Promise(resolve => setTimeout(resolve, 50))
              }
              
              // Verificar que haya un contrato seleccionado
              if (!values?.templateHomologada || !Array.isArray(values.templateHomologada) || values.templateHomologada.length === 0 || !values.templateHomologada[0]?.value) {
                // Si el usuario borró el contrato, resetear las refs para permitir nueva selección
                contratoOrigenYaProcesadoRef.current = false
                procesandoContratoRef.current = null
                setUltimoContratoId(null)
                return
              }
              
              const contratoId = values.templateHomologada[0].value
              
              // CRÍTICO: Si el contrato cambió (es diferente al último), resetear la ref para permitir procesarlo
              if (ultimoContratoId !== null && contratoId !== ultimoContratoId) {
                contratoOrigenYaProcesadoRef.current = false
                procesandoContratoRef.current = null
              }
              
              // Si este contrato origen ya fue procesado y aceptado, NO volver a abrir el modal
              if (contratoOrigenYaProcesadoRef.current && contratoId === ultimoContratoId) {
                return
              }
              
              // CRÍTICO: LOCK INMEDIATO - Si ya hay un contrato siendo procesado, bloquear
              if (procesandoContratoRef.current !== null) {
                return
              }
              
              // Establecer el lock INMEDIATAMENTE
              procesandoContratoRef.current = contratoId
              
              // Guardar el ID del contrato seleccionado en Homologada Origen
              localStorage.setItem('contratoOrigenSeleccionado', contratoId.toString())
              
              setIsLoadingContrato(true)
              setUltimoContratoId(contratoId)
              
              localStorage.setItem('estructurasSeleccionadas', JSON.stringify([]))
              localStorage.setItem('estructurasSeleccionadasConNombres', JSON.stringify([])) // CRÍTICO: También limpiar los nombres
              localStorage.setItem('estructurasMultiples', JSON.stringify([]))
              setContratosMultiplesProcesados(new Set())
              // Limpiar también las refs cuando se selecciona un nuevo contrato origen
              contratosMultiplesYaProcesadosRef.current.clear()
              contratoOrigenYaProcesadoRef.current = false // Resetear para permitir procesar el nuevo contrato origen
              
              try {
                  setContratoSeleccionadoParaModal({ id: contratoId, esContratoBase: true })
                  
                  // Cargar estructuras del contrato
                  const [dataEstructuras, dataEstructurasFijas]: any = await Promise.all([
                    callSP('amd_getEstructuraByContrato', [
                      { text: 'contrato', value: contratoId.toString() }
                    ]),
                    callSP('amd_getEstructuraFijaByContrato', [
                      { text: 'contrato', value: contratoId.toString() }
                    ])
                  ])
                  
                    
                    // Guardar datos originales de estructuras fijas para referencia posterior
                    if (dataEstructurasFijas?.data?.status === '200' && Array.isArray(dataEstructurasFijas.data.result)) {
                      setDataEstructurasFijasOriginales(dataEstructurasFijas.data.result)
                    }
                    
                  // Obtener IDs de estructuras fijas para EXCLUIRLAS de las normales
                    const estructurasFijasIds = new Set()
                  
                    if (dataEstructurasFijas?.data?.status === '200' && Array.isArray(dataEstructurasFijas.data.result)) {
                      dataEstructurasFijas.data.result.forEach((ef: any) => {
                      const id = ef.id_estructura || ef.id
                      if (id) {
                        estructurasFijasIds.add(id)
                        estructurasFijasIds.add(ef.id)
                      }
                      })
                    }
                    
                  // Procesar estructuras NORMALES desde amd_getEstructuraByContrato
                  // EXCLUYENDO las que son fijas
                    const estructurasNormales: any[] = []
                  
                  if (dataEstructuras?.data?.status === '200' && Array.isArray(dataEstructuras.data.result)) {
                    const nombresExcluidos = ['Costo Planificado', 'Costo Ajustado', 'Diferencial', 'Comensales']
                    const estructurasFiltradas = dataEstructuras.data.result.filter((e: any) => {
                      const nombre = e.ess_nombre || e.nombre || e.structure || ''
                      return nombre !== '' && !nombresExcluidos.includes(nombre)
                    })
                    
                    // Filtrar EXCLUYENDO las estructuras fijas
                    estructurasFiltradas.forEach((e: any) => {
                      const esEstructuraFija = estructurasFijasIds.has(e.id) || 
                                               estructurasFijasIds.has(e.idO) || 
                                               estructurasFijasIds.has(e.id_estructura)
                      
                      // Solo agregar si NO es estructura fija
                      if (!esEstructuraFija) {
                        estructurasNormales.push({ ...e, checked: true, esEstructuraFija: false })
                      }
                    })
                  }
                  
                  // Procesar estructuras FIJAS SOLO desde amd_getEstructuraFijaByContrato
                  const estructurasFijasArray: any[] = []
                  
                  if (dataEstructurasFijas?.data?.status === '200' && Array.isArray(dataEstructurasFijas.data.result)) {
                    dataEstructurasFijas.data.result.forEach((ef: any) => {
                      // Crear objeto compatible con el formato esperado
                      // Usar rec_nombre como nombre principal (viene del SP amd_getEstructuraFijaByContrato)
                      estructurasFijasArray.push({
                        ...ef,
                        id_estructura: ef.id_estructura || ef.id,
                        ess_nombre: ef.rec_nombre || ef.ess_nombre || ef.nombre || ef.structure || '',
                        nombre: ef.rec_nombre || ef.ess_nombre || ef.nombre || ef.structure || '',
                        rec_nombre: ef.rec_nombre || '',
                        nombreGrupoEstructura: ef.nombreGrupoEstructura || '',
                        checked: true, // CRÍTICO: Por defecto marcadas para facilitar selección
                        esEstructuraFija: true
                      })
                    })
                  }
                    
                    // Combinar: primero normales, luego fijas
                    const estructurasCombinadas = [...estructurasNormales, ...estructurasFijasArray]
                    
                  // CRÍTICO: Verificar si realmente hay estructuras disponibles del SP (antes del filtrado)
                  const totalEstructurasNormalesSP = dataEstructuras?.data?.status === '200' && Array.isArray(dataEstructuras.data.result) ? dataEstructuras.data.result.length : 0
                  const totalEstructurasFijasSP = dataEstructurasFijas?.data?.status === '200' && Array.isArray(dataEstructurasFijas.data.result) ? dataEstructurasFijas.data.result.length : 0
                  const totalEstructurasDisponiblesSP = totalEstructurasNormalesSP + totalEstructurasFijasSP
                  
                  
                  // CRÍTICO: Solo mostrar alerta si NO hay estructuras disponibles del SP
                  // Si hay estructuras disponibles pero todas fueron filtradas, mostrar el modal vacío (el usuario verá que no hay opciones)
                  if (totalEstructurasDisponiblesSP === 0) {
                    warn('No se encontraron estructuras para este contrato')
                    setIsLoadingContrato(false)
                    procesandoContratoRef.current = null // Liberar el lock
                  } else {
                    // Si hay estructuras disponibles del SP, mostrar el modal (aunque esté vacío después del filtrado)
                    setEstructurasModal(estructurasCombinadas)
                    setEstructurasSeleccionadas(estructurasCombinadas)
                    setShowEstructurasModal(true)
                    
                    // Si todas fueron filtradas, mostrar un mensaje informativo
                    if (estructurasCombinadas.length === 0 && totalEstructurasDisponiblesSP > 0) {
                    }
                  }
              } catch (e: any) {
                error('Error al cargar las estructuras del contrato')
                setIsLoadingContrato(false)
                procesandoContratoRef.current = null // Liberar el lock
              }
            },
          },
          {
            columInput: 1,
            type: 'select-checkbox',
            style: { width: "100%" },
            campo: 'templateHomologada2',
            placeholder: 'Placeholder Homologada Multiple',
            campoChk: 'homologada2',
            label: 'Homologada Destino Multiple',
            disabled: esModoEdicion,
            readonlyCheckbox: esModoEdicion,
            onClick: (event: any, setFieldValue: any, values: any) => {
              // En modo edición, no permitir cambios
              if (esModoEdicion) return
              setIsHomologadaInput2(values?.homologada2)
              if (props.setIsHomologada) props.setIsHomologada(values?.homologada2)
              
              // Guardar el estado del checkbox en localStorage
              if (values?.homologada2) {
                localStorage.setItem('homologada2', 'true')
              } else {
                localStorage.setItem('homologada2', 'false')
                // Si se desmarca el checkbox, limpiar el localStorage Y el valor en Formik
                localStorage.removeItem('templateHomologada2')
                // CRÍTICO: Limpiar también el valor del campo para prevenir valores residuales
                setFieldValue('templateHomologada2', [])
              }
            },
            advanceOptions: {
              id: 'templateHomologada2',
              placeholder: 'Seleccionar Contrato',
              multiple: true,
              options: optionContract2,
            },
            className: 'form-control b-0 p-0 w-100 form-control-lg input-contract',
            onChange: async (event: any, setFieldValue: any, values: any) => {
              // CRÍTICO: En modo edición, NO abrir el modal de estructuras
              // Solo cargar los valores en el formulario
              if (props.editData && editData) {
                return
              }
              
              // CRÍTICO: Si el checkbox NO está marcado, NO permitir selección
              // Esto previene que el componente cargue automáticamente valores
              if (!values?.homologada2) {
                // Limpiar cualquier valor que se haya cargado automáticamente
                setFieldValue('templateHomologada2', [])
                return
              }
              
              // CRÍTICO: Leer los contratos seleccionados INMEDIATAMENTE
              let contratosSeleccionados = []
              
              if (event?.current?.state?.selected && Array.isArray(event.current.state.selected)) {
                contratosSeleccionados = event.current.state.selected
              } else if (values?.templateHomologada2 && Array.isArray(values.templateHomologada2)) {
                contratosSeleccionados = values.templateHomologada2
              }
              
              const contratosArray = Array.isArray(contratosSeleccionados) ? contratosSeleccionados : (contratosSeleccionados ? [contratosSeleccionados] : [])
              
              // CRÍTICO: Detectar contratos eliminados y removerlos de la ref para permitir re-selección
              const contratosActualesIds = new Set(
                contratosArray.map((c: any) => {
                  const id = c?.value || c?.id || c
                  return id
                }).filter((id: any) => id)
              )
              
              // Remover de la ref los contratos que ya no están seleccionados
              const contratosEliminados: number[] = []
              contratosMultiplesYaProcesadosRef.current.forEach((id: number) => {
                if (!contratosActualesIds.has(id)) {
                  contratosEliminados.push(id)
                }
              })
              
              if (contratosEliminados.length > 0) {
                contratosEliminados.forEach((id: number) => {
                  contratosMultiplesYaProcesadosRef.current.delete(id)
                })
              }
              
              // CRÍTICO: Encontrar el contrato NUEVO INMEDIATAMENTE
              let contratoNuevo = null
              
              for (const contrato of contratosArray) {
                const contratoId = contrato?.value || contrato?.id || contrato
                
                // Verificar si este contrato ya fue procesado
                if (contratoId && !contratosMultiplesYaProcesadosRef.current.has(contratoId)) {
                  contratoNuevo = contrato
                  break
                }
              }
              
              // Si no hay contrato nuevo, solo actualizar valores y salir
              if (!contratoNuevo) {
                // Actualizar Formik con el valor del componente
                if (contratosSeleccionados.length > 0) {
                  setFieldValue('templateHomologada2', contratosSeleccionados)
                } else {
                  setFieldValue('templateHomologada2', [])
                }
                
                // Guardar en localStorage
                if (contratosSeleccionados.length > 0) {
                  const contratosIds = contratosSeleccionados.map((c: any) => {
                    if (typeof c === 'object' && c !== null) {
                      return c.value || c.id || c
                    }
                    return c
                  }).filter((id: any) => id && id !== '' && id !== 0)
                  
                  const contratosIdsUnicos = Array.from(new Set(contratosIds))
                  localStorage.setItem('templateHomologada2', JSON.stringify(contratosIdsUnicos))
                }
                
                return
              }
              
              const contratoId = contratoNuevo?.value || contratoNuevo?.id || contratoNuevo
              
              // CRÍTICO: LOCK INMEDIATO - Verificar Y establecer en una sola operación
              if (procesandoContratoRef.current !== null) {
                return
              }
              
              // Establecer el lock INMEDIATAMENTE
              procesandoContratoRef.current = contratoId
              
              // Ahora sí, actualizar valores (después del lock)
              // Actualizar Formik con el valor del componente
              if (contratosSeleccionados.length > 0) {
                setFieldValue('templateHomologada2', contratosSeleccionados)
              } else {
                setFieldValue('templateHomologada2', [])
              }
              
              // Guardar en localStorage
              if (contratosSeleccionados.length > 0) {
                const contratosIds = contratosSeleccionados.map((c: any) => {
                  if (typeof c === 'object' && c !== null) {
                    return c.value || c.id || c
                  }
                  return c
                }).filter((id: any) => id && id !== '' && id !== 0)
                
                const contratosIdsUnicos = Array.from(new Set(contratosIds))
                localStorage.setItem('templateHomologada2', JSON.stringify(contratosIdsUnicos))
              }
              
              // Marcar que estamos abriendo el modal
              setIsLoadingContrato(true)
              abriendoModalRef.current = true
              ultimoContratoProcesadoRef.current = contratoId
              
              try {
                setContratoSeleccionadoParaModal({ id: contratoId, esContratoBase: false })
                
                // Cargar estructuras del contrato
                const [dataEstructuras, dataEstructurasFijas]: any = await Promise.all([
                  callSP('amd_getEstructuraByContrato', [
                    { text: 'contrato', value: contratoId.toString() }
                  ]),
                  callSP('amd_getEstructuraFijaByContrato', [
                    { text: 'contrato', value: contratoId.toString() }
                  ])
                ])
                
                // CRÍTICO: Obtener estructuras ya seleccionadas en otros contratos para evitar duplicados
                // Usar nombres de estructuras para comparación (más robusto que solo IDs)
                let nombresEstructurasYaSeleccionadas: Set<string> = new Set()
                let idsEstructurasYaSeleccionadas: Set<string> = new Set()
                
                // Sets SEPARADOS para estructuras FIJAS (solo id_receta)
                let idsEstructurasFijasYaSeleccionadas: Set<string> = new Set()
                let nombresEstructurasFijasYaSeleccionadas: Set<string> = new Set()
                
                // 1. Obtener estructuras NORMALES del contrato origen (base) - SOLO las que fueron SELECCIONADAS
                // CRÍTICO: Usar estructurasSeleccionadasConNombres que contiene las estructuras REALMENTE seleccionadas
                try {
                    const estructurasSeleccionadasConNombresStr = localStorage.getItem('estructurasSeleccionadasConNombres')
                    if (estructurasSeleccionadasConNombresStr && estructurasSeleccionadasConNombresStr !== '[]' && estructurasSeleccionadasConNombresStr !== '') {
                      const estructurasSeleccionadasConNombres = JSON.parse(estructurasSeleccionadasConNombresStr)
                      if (Array.isArray(estructurasSeleccionadasConNombres)) {
                        estructurasSeleccionadasConNombres.forEach((est: any) => {
                          // Agregar por nombre (normalizado)
                          if (est.nombre) nombresEstructurasYaSeleccionadas.add(est.nombre.toLowerCase().trim())
                          // Agregar por ID
                          if (est.id) idsEstructurasYaSeleccionadas.add(est.id?.toString())
                        })
                      }
                    }
                    // Fallback: si no hay con nombres, usar solo IDs de estructurasSeleccionadas
                    const estructurasSeleccionadasStr = localStorage.getItem('estructurasSeleccionadas')
                    if (estructurasSeleccionadasStr && estructurasSeleccionadasStr !== '[]' && estructurasSeleccionadasStr !== '') {
                      const estructurasSeleccionadasIds = JSON.parse(estructurasSeleccionadasStr)
                      if (Array.isArray(estructurasSeleccionadasIds)) {
                        estructurasSeleccionadasIds.forEach((id: any) => {
                          idsEstructurasYaSeleccionadas.add(id?.toString())
                        })
                      }
                    }
                  } catch (e) {
                  }
                  
                  // 2. Obtener estructuras de otros contratos múltiples - por nombre Y todos los IDs posibles
                  try {
                    const estructurasMultiplesStr = localStorage.getItem('estructurasMultiples')
                    if (estructurasMultiplesStr && estructurasMultiplesStr !== '[]' && estructurasMultiplesStr !== '') {
                      const estructurasMultiples = JSON.parse(estructurasMultiplesStr)
                      if (Array.isArray(estructurasMultiples)) {
                        estructurasMultiples.forEach((est: any) => {
                          // Agregar por nombre (principal)
                          if (est.nombre) nombresEstructurasYaSeleccionadas.add(est.nombre.toLowerCase().trim())
                          // Agregar TODOS los IDs posibles que se guardaron
                          if (est.id) idsEstructurasYaSeleccionadas.add(est.id?.toString())
                          if (est.ess_codigo) idsEstructurasYaSeleccionadas.add(est.ess_codigo?.toString())
                          if (est.id_estructura) idsEstructurasYaSeleccionadas.add(est.id_estructura?.toString())
                          if (est.id_estructura_contrato) idsEstructurasYaSeleccionadas.add(est.id_estructura_contrato?.toString())
                        })
                      }
                    }
                  } catch (e) {}
                  
                  // 3. Obtener estructuras FIJAS del contrato origen (base) - SOLO las que fueron SELECCIONADAS
                  // CRÍTICO: Cargar las estructuras fijas del contrato base desde el SP para obtener sus nombres
                  // pero SOLO para las que están en estructurasFijasSeleccionadas (las que realmente fueron seleccionadas)
                  try {
                    const contratoOrigenSeleccionadoStr = localStorage.getItem('contratoOrigenSeleccionado')
                    if (contratoOrigenSeleccionadoStr && contratoOrigenSeleccionadoStr !== '' && contratoOrigenSeleccionadoStr !== 'null') {
                      const contratoOrigenId = parseInt(contratoOrigenSeleccionadoStr)
                      if (!isNaN(contratoOrigenId)) {
                        const estructurasFijasSeleccionadasStr = localStorage.getItem('estructurasFijasSeleccionadas')
                        if (estructurasFijasSeleccionadasStr && estructurasFijasSeleccionadasStr !== '[]' && estructurasFijasSeleccionadasStr !== '') {
                          const estructurasFijasSeleccionadas = JSON.parse(estructurasFijasSeleccionadasStr)
                          if (Array.isArray(estructurasFijasSeleccionadas) && estructurasFijasSeleccionadas.length > 0) {
                            // Cargar las estructuras fijas del contrato base para obtener sus nombres
                            const dataEstructurasFijasBase: any = await callSP('amd_getEstructuraFijaByContrato', [
                              { text: 'contrato', value: contratoOrigenId.toString() }
                            ])
                            
                            if (dataEstructurasFijasBase?.data?.status === '200' && Array.isArray(dataEstructurasFijasBase.data.result)) {
                              estructurasFijasSeleccionadas.forEach((ef: any) => {
                                // Buscar la estructura fija en los datos del SP para obtener su nombre
                                // CRÍTICO: En amd_getEstructuraFijaByContrato, id_estructura siempre es 0, así que comparar principalmente por id_receta
                                const estructuraFijaBase = dataEstructurasFijasBase.data.result.find((efBase: any) => 
                                  // Comparar principalmente por id_receta (identificador principal)
                                  efBase.id_receta?.toString() === ef.id_receta?.toString() ||
                                  // También comparar por id (ID del registro) como respaldo
                                  efBase.id?.toString() === ef.id?.toString()
                                )
                                
                                if (estructuraFijaBase) {
                                  // Usar rec_nombre como nombre principal (viene del SP amd_getEstructuraFijaByContrato)
                                  const nombreFija = estructuraFijaBase.rec_nombre || estructuraFijaBase.ess_nombre || estructuraFijaBase.nombre
                                  if (nombreFija) {
                                    nombresEstructurasFijasYaSeleccionadas.add(nombreFija.toLowerCase().trim())
                                  }
                                  
                                  // CRÍTICO: NO agregar id_estructura si es 0 (todas las estructuras fijas tienen id_estructura: 0)
                                  // Solo agregar id_receta (identificador principal) al Set de estructuras FIJAS
                                  if (estructuraFijaBase.id_receta) {
                                    idsEstructurasFijasYaSeleccionadas.add(estructuraFijaBase.id_receta?.toString())
                                  }
                                } else {
                                  // Fallback: agregar solo los IDs guardados (NO agregar id_estructura si es 0)
                                  // CRÍTICO: Solo agregar id_receta (identificador principal) al Set de estructuras FIJAS
                                  if (ef.id_receta) {
                                    idsEstructurasFijasYaSeleccionadas.add(ef.id_receta?.toString())
                                  }
                                }
                              })
                            }
                          }
                        }
                      }
                    }
                  } catch (e) {
                  }
                  
                  // 4. Obtener estructuras fijas múltiples ya seleccionadas - por nombre Y todos los IDs
                  // CRÍTICO: Cargar las estructuras fijas de cada contrato múltiple desde el SP para obtener sus nombres
                  try {
                    const estructurasFijasMultiplesStr = localStorage.getItem('estructurasFijasMultiples')
                    if (estructurasFijasMultiplesStr && estructurasFijasMultiplesStr !== '[]' && estructurasFijasMultiplesStr !== '') {
                      const estructurasFijasMultiples = JSON.parse(estructurasFijasMultiplesStr)
                      if (Array.isArray(estructurasFijasMultiples)) {
                        // Agrupar por contratoId para hacer una sola llamada por contrato
                        const contratosIdsSet = new Set(estructurasFijasMultiples.map((ef: any) => ef.contratoId).filter((id: any) => id))
                        const contratosIds = Array.from(contratosIdsSet)
                        
                        // Cargar estructuras fijas de cada contrato múltiple para obtener sus nombres
                        // CRÍTICO: NO agregar al Set las estructuras fijas del contrato que se está procesando actualmente
                        // Solo agregar las estructuras fijas de OTROS contratos múltiples
                        for (const contratoIdMultiple of contratosIds) {
                          // CRÍTICO: Si es el mismo contrato que se está procesando, NO agregar sus estructuras fijas al Set
                          // Esto permite que las estructuras fijas del contrato actual se muestren en el modal
                          if (contratoIdMultiple === contratoId) {
                            continue
                          }
                          
                          try {
                            const dataEstructurasFijasMultiple: any = await callSP('amd_getEstructuraFijaByContrato', [
                              { text: 'contrato', value: contratoIdMultiple.toString() }
                            ])
                            
                            if (dataEstructurasFijasMultiple?.data?.status === '200' && Array.isArray(dataEstructurasFijasMultiple.data.result)) {
                              // Filtrar solo las estructuras fijas seleccionadas de este contrato
                              const estructurasFijasDeEsteContrato = estructurasFijasMultiples.filter((ef: any) => ef.contratoId === contratoIdMultiple)
                              
                              estructurasFijasDeEsteContrato.forEach((ef: any) => {
                                // Buscar la estructura fija en los datos del SP
                                // CRÍTICO: En amd_getEstructuraFijaByContrato, id_estructura siempre es 0, así que comparar principalmente por id_receta
                                const estructuraFijaOriginal = dataEstructurasFijasMultiple.data.result.find((efBase: any) => 
                                  // Comparar principalmente por id_receta (identificador principal)
                                  efBase.id_receta?.toString() === ef.id_receta?.toString() ||
                                  // También comparar por id (ID del registro) como respaldo
                                  efBase.id?.toString() === ef.id?.toString()
                                )
                                
                                if (estructuraFijaOriginal) {
                                  // Usar rec_nombre como nombre principal (viene del SP amd_getEstructuraFijaByContrato)
                                  const nombreFija = estructuraFijaOriginal.rec_nombre || estructuraFijaOriginal.ess_nombre || estructuraFijaOriginal.nombre
                                  if (nombreFija) {
                                    nombresEstructurasFijasYaSeleccionadas.add(nombreFija.toLowerCase().trim())
                                  }
                                  
                                  // CRÍTICO: NO agregar id_estructura si es 0 (todas las estructuras fijas tienen id_estructura: 0)
                                  // Solo agregar id_receta (identificador principal) al Set de estructuras FIJAS
                                  if (estructuraFijaOriginal.id_receta) {
                                    idsEstructurasFijasYaSeleccionadas.add(estructuraFijaOriginal.id_receta?.toString())
                                  }
                                } else {
                                  // Fallback: agregar solo los IDs guardados (NO agregar id_estructura si es 0)
                                  // CRÍTICO: Solo agregar id_receta (identificador principal) al Set de estructuras FIJAS
                                  if (ef.id_receta) {
                                    idsEstructurasFijasYaSeleccionadas.add(ef.id_receta?.toString())
                                  }
                                }
                              })
                            }
                          } catch (e) {
                          }
                        }
                      }
                    }
                  } catch (e) {
                  }
                  
                      
                      // Guardar datos originales de estructuras fijas para referencia posterior (contratos múltiples)
                      if (dataEstructurasFijas?.data?.status === '200' && Array.isArray(dataEstructurasFijas.data.result)) {
                        // Combinar con las existentes, marcando el contrato de origen
                        const estructurasFijasConContrato = dataEstructurasFijas.data.result.map((ef: any) => ({
                          ...ef,
                          contratoOrigen: contratoId
                        }))
                        setDataEstructurasFijasOriginales((prev: any[]) => [...prev, ...estructurasFijasConContrato])
                      }
                      
                  // Obtener IDs de estructuras fijas para EXCLUIRLAS de las normales
                      const estructurasFijasIds = new Set()
                  
                      if (dataEstructurasFijas?.data?.status === '200' && Array.isArray(dataEstructurasFijas.data.result)) {
                        dataEstructurasFijas.data.result.forEach((ef: any) => {
                      const id = ef.id_estructura || ef.id
                      if (id) {
                        estructurasFijasIds.add(id)
                          estructurasFijasIds.add(ef.id)
                      }
                        })
                      }
                      
                  // Procesar estructuras NORMALES desde amd_getEstructuraByContrato
                  // EXCLUYENDO las que son fijas Y las que ya fueron seleccionadas en otros contratos
                      const estructurasNormales: any[] = []
                  
                  if (dataEstructuras?.data?.status === '200' && Array.isArray(dataEstructuras.data.result)) {
                    const nombresExcluidos = ['Costo Planificado', 'Costo Ajustado', 'Diferencial', 'Comensales']
                    const estructurasFiltradas = dataEstructuras.data.result.filter((e: any) => {
                      const nombre = e.ess_nombre || e.nombre || e.structure || ''
                      return nombre !== '' && !nombresExcluidos.includes(nombre)
                    })
                    
                    // Filtrar EXCLUYENDO las estructuras fijas Y las ya seleccionadas
                      estructurasFiltradas.forEach((e: any) => {
                        const esEstructuraFija = estructurasFijasIds.has(e.id) || 
                                                 estructurasFijasIds.has(e.idO) || 
                                                 estructurasFijasIds.has(e.id_estructura)
                        
                      // Verificar si ya fue seleccionada en otro contrato (por TODOS los IDs posibles o por nombre)
                      const idsPosibles = [
                        e.id?.toString(),
                        e.idO?.toString(),
                        e.id_estructura?.toString(),
                        e.ess_codigo?.toString(),
                        e.id_estructura_contrato?.toString()
                      ].filter((id: any) => id && id !== 'undefined' && id !== 'null')
                      
                      const nombreEstructura = (e.ess_nombre || e.nombre || e.structure || '').toLowerCase().trim()
                      
                      // Verificar si alguno de los IDs posibles ya fue seleccionado
                      const yaSeleccionadaPorId = idsPosibles.some((id: string) => idsEstructurasYaSeleccionadas.has(id))
                      const yaSeleccionadaPorNombre = nombreEstructura && nombresEstructurasYaSeleccionadas.has(nombreEstructura)
                      const yaSeleccionada = yaSeleccionadaPorId || yaSeleccionadaPorNombre
                      
                      // Solo agregar si NO es estructura fija Y NO fue seleccionada en otro contrato
                      if (!esEstructuraFija && !yaSeleccionada) {
                        estructurasNormales.push({ ...e, checked: true, esEstructuraFija: false, contratoOrigen: contratoId })
                      } else if (yaSeleccionada) {
                      }
                    })
                  }
                  
                  // Procesar estructuras FIJAS SOLO desde amd_getEstructuraFijaByContrato
                  // EXCLUYENDO las que ya fueron seleccionadas en otros contratos
                  const estructurasFijasArray: any[] = []
                  const estructurasFijasDescartadas: any[] = []
                  
                  if (dataEstructurasFijas?.data?.status === '200' && Array.isArray(dataEstructurasFijas.data.result)) {
                    dataEstructurasFijas.data.result.forEach((ef: any) => {
                      // Verificar si ya fue seleccionada en otro contrato (por id_receta o por nombre)
                      // CRÍTICO: Usar rec_nombre como nombre principal (viene del SP amd_getEstructuraFijaByContrato)
                      const nombreEstructuraFija = (ef.rec_nombre || ef.ess_nombre || ef.nombre || ef.structure || '').toLowerCase().trim()
                      
                      // CRÍTICO: Para estructuras fijas, solo comparar por id_receta (identificador principal)
                      const idReceta = ef.id_receta?.toString()
                      
                      // Verificar si el id_receta ya fue seleccionado (usar Set de estructuras FIJAS)
                      const yaSeleccionadaPorId = idReceta && idsEstructurasFijasYaSeleccionadas.has(idReceta)
                      const yaSeleccionadaPorNombre = nombreEstructuraFija && nombresEstructurasFijasYaSeleccionadas.has(nombreEstructuraFija)
                      const yaSeleccionada = yaSeleccionadaPorId || yaSeleccionadaPorNombre
                      
                      // Solo agregar si NO fue seleccionada en otro contrato
                      if (!yaSeleccionada) {
                        estructurasFijasArray.push({
                          ...ef,
                          id_estructura: ef.id_estructura || ef.id,
                          ess_nombre: ef.rec_nombre || ef.ess_nombre || ef.nombre || ef.structure || '',
                          nombre: ef.rec_nombre || ef.ess_nombre || ef.nombre || ef.structure || '',
                          rec_nombre: ef.rec_nombre || '',
                          nombreGrupoEstructura: ef.nombreGrupoEstructura || '',
                          checked: true, // CRÍTICO: Por defecto marcadas para facilitar selección
                          esEstructuraFija: true,
                          contratoOrigen: contratoId
                        })
                      } else {
                        // Estructura fija descartada porque ya fue seleccionada
                        estructurasFijasDescartadas.push({
                          id_receta: ef.id_receta,
                          nombre: ef.rec_nombre,
                          razon: yaSeleccionadaPorId ? `id_receta ${ef.id_receta} ya seleccionado` : `nombre "${ef.rec_nombre}" ya seleccionado`
                        })
                      }
                    })
                    
                  } else {
                  }
                      
                      // Combinar: primero normales, luego fijas
                      const estructurasCombinadas = [...estructurasNormales, ...estructurasFijasArray]
                      
                  // CRÍTICO: Verificar si realmente hay estructuras disponibles del SP (antes del filtrado)
                  const totalEstructurasNormalesSP = dataEstructuras?.data?.status === '200' && Array.isArray(dataEstructuras.data.result) ? dataEstructuras.data.result.length : 0
                  const totalEstructurasFijasSP = dataEstructurasFijas?.data?.status === '200' && Array.isArray(dataEstructurasFijas.data.result) ? dataEstructurasFijas.data.result.length : 0
                  const totalEstructurasDisponiblesSP = totalEstructurasNormalesSP + totalEstructurasFijasSP
                  
                  
                  // CRÍTICO: Solo mostrar alerta si NO hay estructuras disponibles del SP
                  // Si hay estructuras disponibles pero todas fueron filtradas, mostrar el modal vacío (el usuario verá que no hay opciones)
                  if (totalEstructurasDisponiblesSP === 0) {
                    warn('No se encontraron estructuras para este contrato')
                    setIsLoadingContrato(false)
                    abriendoModalRef.current = false
                    ultimoContratoProcesadoRef.current = null
                  } else {
                    // Si hay estructuras disponibles del SP, mostrar el modal (aunque esté vacío después del filtrado)
                      setEstructurasModal(estructurasCombinadas)
                      setEstructurasSeleccionadas(estructurasCombinadas)
                      setShowEstructurasModal(true)
                      
                    // Si todas fueron filtradas, mostrar un mensaje informativo
                    if (estructurasCombinadas.length === 0 && totalEstructurasDisponiblesSP > 0) {
                    }
                    }
              } catch (e: any) {
                error('Error al cargar las estructuras del contrato')
                // Si hay error, liberar el lock para poder reintentar
                setIsLoadingContrato(false)
                abriendoModalRef.current = false
                ultimoContratoProcesadoRef.current = null
                procesandoContratoRef.current = null
              }
            },
          },
          {
            columInput: 1,
            campo: 'templateType',
            label: 'Tipo de Plantilla',
            type: 'autocomplete',
            advanceOptions: {
              id: 'templateType',
              placeholder: 'Ingrese tipo de plantilla',
              multiple: false,
              options: templateOptions,
            },
            disabled: _state.plantilla > 0 ? true : isHomologadaInput,
            className: 'form-control b-0 p-0 form-control-lg input-contract',
            onChange: async (event: any, setFieldValue, values) => {
              let type: any = null
              if (values?.templateType && Array.isArray(values.templateType) && values.templateType.length > 0) {
                type = values.templateType[0].value

                if (type == '3') setFieldValue('frequencyCycle', 28)
                else setFieldValue('frequencyCycle', 0)
              }
            },
          },
          {
            columInput: 1,
            placeholder: 'Ingrese ciclo de frecuencia',
            type: 'number',
            campo: 'frequencyCycle',
            id: 'frequencyCycle',
            label: 'Ciclo de frecuencia',
            className: 'form-control form-control-lg input-contract',
            disabled: _state.plantilla > 0 ? true : isHomologadaInput,
            hideInput: hideFrequencyCycle,
            onBlur: async (event: any, setFieldValue: any, values: any) => {
              let type: any = null
              if (values?.templateType && Array.isArray(values.templateType) && values.templateType.length > 0) {
                type = values.templateType[0].value
              }

              frecuenciaMultiplo(event, type, setFieldValue, values)
            },
          },
          {
            columInput: 1,
            campo: 'frequencyType',
            label: 'Tipo de frecuencia',
            type: 'autocomplete',
            disabled: _state.plantilla > 0 ? true : isHomologadaInput,
            advanceOptions: {
              id: 'frequencyType',
              placeholder: 'Ingrese tipo de frecuencia',
              multiple: false,
              options: [
                { text: 'Sodexo', value: 0 },
                { text: 'Contractual', value: 1 },
              ],
            },
            className: 'form-control b-0 p-0 form-control-lg input-contract',
          },
          {
            columInput: 1,
            campo: 'place',
            label: 'Sitio',
            type: 'autocomplete',
            advanceOptions: {
              id: 'palce-input',
              placeholder: 'Ingrese sitio',
              multiple: false,
              options: arrSitios,
            },
            className: 'form-control b-0 p-0 form-control-lg input-contract',
            disabled: _state.plantilla > 0 ? true : false,
            onChange: async (event: any, setFieldValue: any, values: any) => {
              if (values?.place && Array.isArray(values.place) && values.place.length > 0) {
              props.setLoad(true)
              const ceco = values.place[0]
              if (ceco?.value && ceco?.value != '') {
                try {
                  await getServices(ceco.value)
                  props.setLoad(false)
                } catch (e: any) {
                  error(e)
                  props.setLoad(false)
                }
              } else {
                props.setLoad(false)
                }
              }
            },
          },
          {
            columInput: 1,
            campo: 'service',
            label: 'Servicio',
            type: 'autocomplete',
            advanceOptions: {
              id: 'service-input',
              multiple: false,
              placeholder: 'Ingrese servicio',
              options: servicios,
            },
            className: 'form-control b-0 p-0 form-control-lg input-contract',
            disabled: _state.plantilla > 0 ? true : false,
          },
          {
            columInput: 1,
            campo: 'regime',
            label: 'Regimen',
            type: 'autocomplete',
            advanceOptions: {
              id: 'regime-input',
              placeholder: 'Ingrese régimen',
              multiple: false,
              options: data?.regimens || [],
            },
            className: 'form-control b-0 p-0 form-control-lg input-contract',
            disabled: _state.plantilla > 0 ? true : false,
          },
          {
            columInput: 1,
            placeholder: 'Ingrese costo objetivo mensual',
            type: 'number',
            campo: 'monthlyCost',
            label: 'Costo objetivo mensual',
            className: 'form-control form-control-lg input-contract',
            disabled: _state.plantilla > 0 ? true : false,
          },
          {
            columInput: 1,
            placeholder: 'Ingrese Fecha Creacion',
            type: 'date',
            campo: 'fechaCreacion',
            label: 'Fecha Creación',
            className: 'form-control form-control-lg input-contract',
            disabled: _state.plantilla > 0 ? true : false,
          }
        ])
      }

      if (props.editData) {
        setEditData(false)
        props.formikProps?.setFieldValue('frequencyType', props.editData.frequencyType)
        props.formikProps?.setFieldValue('frequencyCycle', props.editData.frequencyCycle)
        props.formikProps?.setFieldValue('templateType', props.editData.templateType)
        props.formikProps?.setFieldValue('weeks', props.editData.weeks)
        if (editData) {
          props.formikProps?.setFieldValue('place', props.editData.place)
        }

        props.formikProps?.setFieldValue('templateHomologada', props.editData.templateHomologada)
        // Solo actualizar homologada si el usuario no lo ha marcado manualmente
        if (props.formikProps?.values?.homologada === undefined) {
          props.formikProps?.setFieldValue('homologada', props.editData.homologada)
        }
        
        // CRÍTICO: Cargar templateHomologada2 y homologada2 en modo edición
        if (props.editData.templateHomologada2 && Array.isArray(props.editData.templateHomologada2) && props.editData.templateHomologada2.length > 0) {
          props.formikProps?.setFieldValue('templateHomologada2', props.editData.templateHomologada2)
          props.formikProps?.setFieldValue('homologada2', true)
        }
        
        props.formikProps?.setFieldValue('regime', props.editData.regime)
        props.formikProps?.setFieldValue('service', props.editData.service)
        props.formikProps?.setFieldValue('monthlyCost', props.editData.monthlyCost)
        props.formikProps?.setFieldValue('fechaCreacion', new Date(props.editData.fechaCreacion).toISOString().substring(0, 10))
        props.formikProps?.setFieldValue('mondayId', props.editData.mondayId)
        props.formikProps?.setFieldValue('tuesdayId', props.editData.tuesdayId)
        props.formikProps?.setFieldValue('wednesdayId', props.editData.wednesdayId)
        props.formikProps?.setFieldValue('thursdayId', props.editData.thursdayId)
        props.formikProps?.setFieldValue('fridayId', props.editData.fridayId)
        props.formikProps?.setFieldValue('saturdayId', props.editData.saturdayId)
        props.formikProps?.setFieldValue('sundayId', props.editData.sundayId)

        props.formikProps?.setFieldValue('monday', props.editData.monday)
        props.formikProps?.setFieldValue('tuesday', props.editData.tuesday)
        props.formikProps?.setFieldValue('wednesday', props.editData.wednesday)
        props.formikProps?.setFieldValue('thursday', props.editData.thursday)
        props.formikProps?.setFieldValue('friday', props.editData.friday)
        props.formikProps?.setFieldValue('saturday', props.editData.saturday)
        props.formikProps?.setFieldValue('sunday', props.editData.sunday)

        props.formikProps?.setFieldValue('quantityMonday', props.editData.quantityMonday)
        props.formikProps?.setFieldValue('quantityTuesday', props.editData.quantityTuesday)
        props.formikProps?.setFieldValue('quantityWednesday', props.editData.quantityWednesday)
        props.formikProps?.setFieldValue('quantityThursday', props.editData.quantityThursday)
        props.formikProps?.setFieldValue('quantityFriday', props.editData.quantityFriday)
        props.formikProps?.setFieldValue('quantitySaturday', props.editData.quantitySaturday)
        props.formikProps?.setFieldValue('quantitySunday', props.editData.quantitySunday)

        props.formikProps?.setFieldValue(
          'ruleColorDistribution',
          props.editData.ruleColorDistribution
        )
        props.formikProps?.setFieldValue('ruleRecipeRepeat', props.editData.ruleRecipeRepeat)
        props.formikProps?.setFieldValue('ruleDescriptiveCost', props.editData.ruleDescriptiveCost)
        props.formikProps?.setFieldValue('ruleGarnitureCruce', props.editData.ruleGarnitureCruce)
        props.formikProps?.setFieldValue('ruleNameRepeat', props.editData.ruleNameRepeat)
        props.formikProps?.setFieldValue('ruleRemoriceEfect', props.editData.ruleRemoriceEfect)
        props.formikProps?.setFieldValue(
          'ruleComplexityRecipes',
          props.editData.ruleComplexityRecipes
        )
        props.formikProps?.setFieldValue('ruleCookingMethod', props.editData.ruleCookingMethod)
        props.formikProps?.setFieldValue('ruleCruceRule', props.editData.ruleCruceRule)
        if (props.editData.ruleCruceRule) {
          props.formikProps?.setFieldValue('reglaSitio', props.editData.reglaSitio)
          props.formikProps?.setFieldValue('reglaRegimen', props.editData.reglaRegimen)
          props.formikProps?.setFieldValue('reglaServicios', props.editData.reglaServicios)
        }
        if (props.editData.homologada) setReadonlyCkeck(true)
      }
      // Asegurar que el loading esté apagado al final de la inicialización
      props.setLoad(false);
    })()
  }, [props.isReady, props.formikProps?.values.templateType, props.editData, servicios, props.formikProps?.values?.homologada, datastate])

  const checkAll = () => {
    if (props.formikProps?.values) {
      props.formikProps.values.monday = true
      props.formikProps.values.tuesday = true
      props.formikProps.values.wednesday = true
      props.formikProps.values.thursday = true
      props.formikProps.values.friday = true
      props.formikProps.values.saturday = true
      props.formikProps.values.sunday = true
    }
  }

  const getServices = async (ceco: number) => {
    try {
      const dataServices: any = await callSP('amd_getServiciosByCeco', [
        { text: 'ceco', value: ceco.toString() },
      ])
      if (dataServices.data.status != '200') {
        throw 'Error al consultar servicios!'
      }

      setServicios(
        quitarDuplicadoReceta(
          dataServices.data.result.map((e: any) => {
            return {
              ...e,
              text: `${e.ser_codigo} - ${e.ser_nombre}`,
              value: e.ser_codigo,
            }
          }),
          'ser_codigo'
        )
      )
    } catch (e: any) {
      error(e)
    }
  }

  const onDaysSelected = (values: any) => {
    const { monday, tuesday, wednesday, thursday, friday, saturday, sunday } = values
    const arrDays = [monday, tuesday, wednesday, thursday, friday, saturday, sunday]
    const daysQyt = arrDays.filter((e: any) => e).length
    setDaysSelected(daysQyt)
    return daysQyt
  }

  const frecuenciaMultiplo = (e: any, type: any, setFieldValue: any, values: any) => {
    const days = onDaysSelected(values)
    if (type) {
      const qyt = parseInt(e.target.value)
      if (qyt && !Number.isNaN(qyt)) {
        if (type == 1) {
          const isMultiplo = qyt % days === 0

          if (isMultiplo) {
            const semanas = qyt / days

            setWeeks(semanas)
            setFieldValue('weeks', semanas)
          } else {
            setFieldValue('frequencyCicle', 0)
            const fc: any = document.getElementById('frequencyCycle1')
            warn(`La cantidan ingresada no es multiplo de ${days}`)
            setTimeout(() => {
              fc.value = ''
            }, 10)
          }
        }

        if (type == 3) setFieldValue('weeks', undefined)
      } else {
        warn(`Ingrese solo números`)
      }
    } else {
      warn('Seleccione el tipo de plantilla')
      setFieldValue('frequencyCycle', 0)
    }
  }

  const handleEstructuraCheckbox = (index: number, checked: boolean) => {
    setEstructurasSeleccionadas((prev) => 
      prev.map((e, i) => i === index ? { ...e, checked } : e)
    )
  }

  const handleAceptarEstructuras = async () => {
    const estructurasMarcadas = estructurasSeleccionadas.filter((e: any) => e.checked)
    
    // Separar estructuras normales y estructuras fijas
    const estructurasNormalesMarcadas = estructurasMarcadas.filter((e: any) => !e.esEstructuraFija)
    const estructurasFijasMarcadas = estructurasMarcadas.filter((e: any) => e.esEstructuraFija)
    
    // Obtener los índices de las estructuras fijas seleccionadas en el modal
    // CRÍTICO: Usar estructurasModal directamente, no estructurasSeleccionadas, para obtener los índices correctos
    const indicesEstructurasFijas = estructurasFijasMarcadas.map((ef: any) => 
      estructurasModal.findIndex((em: any) => 
        (em.id === ef.id || em.idO === ef.id) ||
        (em.id_receta?.toString() === ef.id_receta?.toString() && em.id_receta)
      )
    ).filter((idx: number) => idx !== -1)
    
    if (estructurasFijasMarcadas.length > 0) {
      if (indicesEstructurasFijas.length !== estructurasFijasMarcadas.length) {
      }
    }
    
    if (contratoSeleccionadoParaModal?.esContratoBase) {
      // Guardar estructuras normales (guardar también nombres para validación de duplicados)
      const estructurasIds = estructurasNormalesMarcadas.map((e: any) => e.id || e.idO)
      // También guardar nombres de estructuras para validación de duplicados
      // CRÍTICO: Usar el mismo orden que se usa al comparar (ess_nombre primero, luego nombre, luego structure)
      const estructurasConNombres = estructurasNormalesMarcadas.map((e: any) => ({
        id: e.id || e.idO,
        nombre: (e.ess_nombre || e.nombre || e.structure || '').toLowerCase().trim() // Normalizar el nombre igual que al comparar
      }))
      localStorage.setItem('estructurasSeleccionadas', JSON.stringify(estructurasIds))
      localStorage.setItem('estructurasSeleccionadasConNombres', JSON.stringify(estructurasConNombres))
      localStorage.setItem('contratoBase', contratoSeleccionadoParaModal.id.toString())
      
      // Guardar estructuras fijas seleccionadas específicamente
      // Buscar las estructuras fijas en el modal usando los índices
      const estructurasFijasIds = indicesEstructurasFijas.map((idx: number) => {
        const estructuraModal = estructurasModal[idx]
        
        // Buscar en los datos originales de estructuras fijas del contrato base
        // CRÍTICO: amd_getEstructuraFijaByContrato devuelve id_receta como identificador principal
        // estructuraModal viene de amd_getEstructuraFijaByContrato y tiene id_receta directamente
        // En amd_getEstructuraFijaByContrato, id_estructura siempre es 0, así que debemos comparar por id_receta
        const estructuraFijaOriginal = dataEstructurasFijasOriginales.find((ef: any) => 
          (!ef.contratoOrigen || ef.contratoOrigen === contratoSeleccionadoParaModal.id) &&
          // CRÍTICO: Comparar por id_receta primero (es el identificador principal)
          (ef.id_receta?.toString() === estructuraModal?.id_receta?.toString() ||
           // También comparar por id (ID del registro) como respaldo
           ef.id?.toString() === estructuraModal?.id?.toString() ||
           // Y por id_estructura como último respaldo (aunque siempre es 0 en amd_getEstructuraFijaByContrato)
           (ef.id_estructura?.toString() === estructuraModal?.id_estructura?.toString() && ef.id_estructura !== 0))
        )
        
        // CRÍTICO: estructuraModal viene de amd_getEstructuraFijaByContrato y tiene id_receta directamente
        // Usar id_receta de estructuraModal como primera opción
        return {
          id_estructura: estructuraFijaOriginal?.id_estructura || estructuraModal?.id_estructura || estructuraModal?.id || estructuraModal?.idO || 0,
          id_receta: estructuraFijaOriginal?.id_receta || estructuraModal?.id_receta, // CRÍTICO: id_receta es el identificador principal
          id_grupo_estructura: estructuraFijaOriginal?.id_grupo_estructura || estructuraModal?.id_grupo_estructura,
          contratoId: contratoSeleccionadoParaModal.id
        }
      })
      
      localStorage.setItem('estructurasFijasSeleccionadas', JSON.stringify(estructurasFijasIds))
    } else {
      let estructurasMultiples: any[] = []
      try {
        const estructurasMultiplesStr = localStorage.getItem('estructurasMultiples')
        if (estructurasMultiplesStr && estructurasMultiplesStr !== '[]' && estructurasMultiplesStr !== '') {
          estructurasMultiples = JSON.parse(estructurasMultiplesStr)
          if (!Array.isArray(estructurasMultiples)) {
            estructurasMultiples = []
          }
        }
      } catch (e) {
        estructurasMultiples = []
      }
      
      // Guardar estructuras normales múltiples
      // CRÍTICO: Guardar múltiples IDs posibles para comparación con amd_getDatosByContrato
      const nuevasEstructuras = estructurasNormalesMarcadas.map((e: any) => {
        const estructura = {
          id: e.id || e.idO, // ID principal
          ess_codigo: e.ess_codigo || e.idO || e.id, // Código de estructura (puede ser usado en amd_getDatosByContrato)
          id_estructura: e.id_estructura || e.id || e.idO, // ID de estructura alternativo
          id_estructura_contrato: e.id_estructura_contrato || e.id || e.idO, // ID de estructura contrato (usado en amd_getDatosByContrato)
        contratoId: contratoSeleccionadoParaModal.id,
          nombre: (e.ess_nombre || e.nombre || e.structure || '').toLowerCase().trim() // Normalizar el nombre igual que al comparar
        }
        return estructura
      })
      
      // CRÍTICO: Reemplazar las estructuras del contrato actual, no acumularlas
      // Filtrar las estructuras del contrato actual para eliminar las antiguas
      const estructurasDeOtrosContratos = estructurasMultiples.filter((e: any) => 
        e.contratoId !== contratoSeleccionadoParaModal.id
      )
      
      const todasEstructurasMultiples = [...estructurasDeOtrosContratos, ...nuevasEstructuras]
      localStorage.setItem('estructurasMultiples', JSON.stringify(todasEstructurasMultiples))
      
      // CRÍTICO: Verificar que se guardó correctamente
      const verificarGuardado = localStorage.getItem('estructurasMultiples')
      
      // Guardar estructuras fijas múltiples
      let estructurasFijasMultiples: any[] = []
      try {
        const estructurasFijasMultiplesStr = localStorage.getItem('estructurasFijasMultiples')
        if (estructurasFijasMultiplesStr && estructurasFijasMultiplesStr !== '[]' && estructurasFijasMultiplesStr !== '') {
          estructurasFijasMultiples = JSON.parse(estructurasFijasMultiplesStr)
          if (!Array.isArray(estructurasFijasMultiples)) {
            estructurasFijasMultiples = []
          }
        }
      } catch (e) {
        estructurasFijasMultiples = []
      }
      
      // Buscar las estructuras fijas en el modal usando los índices
      const nuevasEstructurasFijas = indicesEstructurasFijas.map((idx: number) => {
        const estructuraModal = estructurasModal[idx]
        
        // Buscar en los datos originales de estructuras fijas del contrato múltiple
        // CRÍTICO: amd_getEstructuraFijaByContrato devuelve id_receta como identificador principal
        // estructuraModal viene de amd_getEstructuraFijaByContrato y tiene id_receta directamente
        // En amd_getEstructuraFijaByContrato, id_estructura siempre es 0, así que debemos comparar por id_receta
        const estructuraFijaOriginal = dataEstructurasFijasOriginales.find((ef: any) => 
          ef.contratoOrigen === contratoSeleccionadoParaModal.id &&
          // CRÍTICO: Comparar por id_receta primero (es el identificador principal)
          (ef.id_receta?.toString() === estructuraModal?.id_receta?.toString() ||
           // También comparar por id (ID del registro) como respaldo
           ef.id?.toString() === estructuraModal?.id?.toString() ||
           // Y por id_estructura como último respaldo (aunque siempre es 0 en amd_getEstructuraFijaByContrato)
           (ef.id_estructura?.toString() === estructuraModal?.id_estructura?.toString() && ef.id_estructura !== 0))
        )
        
        // CRÍTICO: estructuraModal viene de amd_getEstructuraFijaByContrato y tiene id_receta directamente
        // Usar id_receta de estructuraModal como primera opción
        return {
          id_estructura: estructuraFijaOriginal?.id_estructura || estructuraModal?.id_estructura || estructuraModal?.id || estructuraModal?.idO || 0,
          id_receta: estructuraFijaOriginal?.id_receta || estructuraModal?.id_receta, // CRÍTICO: id_receta es el identificador principal
          id_grupo_estructura: estructuraFijaOriginal?.id_grupo_estructura || estructuraModal?.id_grupo_estructura,
          contratoId: contratoSeleccionadoParaModal.id
        }
      })
      
      // CRÍTICO: Reemplazar las estructuras fijas del contrato actual, no acumularlas
      // Filtrar las estructuras fijas del contrato actual para eliminar las antiguas
      const estructurasFijasDeOtrosContratos = estructurasFijasMultiples.filter((ef: any) => 
        ef.contratoId !== contratoSeleccionadoParaModal.id
      )
      
      const todasEstructurasFijasMultiples = [...estructurasFijasDeOtrosContratos, ...nuevasEstructurasFijas]
      localStorage.setItem('estructurasFijasMultiples', JSON.stringify(todasEstructurasFijasMultiples))
    }
    
    // CRÍTICO: Marcar el contrato como procesado definitivamente
    if (contratoSeleccionadoParaModal?.esContratoBase) {
      // Es el contrato origen - marcarlo como ya procesado
      contratoOrigenYaProcesadoRef.current = true
    } else if (contratoSeleccionadoParaModal?.id) {
      // Es un contrato múltiple - agregarlo al Set
      contratosMultiplesYaProcesadosRef.current.add(contratoSeleccionadoParaModal.id)
    }
    
    // Resetear INMEDIATAMENTE los flags ANTES de cualquier operación asíncrona
    setShowEstructurasModal(false)
    abriendoModalRef.current = false
    setIsLoadingContrato(false)
    procesandoContratoRef.current = null // CRÍTICO: Liberar el lock de procesamiento
    
    // Solo llamar a getDataEdit para el contrato base
    if (contratoSeleccionadoParaModal?.esContratoBase && props.getDataEdit && !props.bloqueado) {
      props.setLoad(true)
      try {
        await props.getDataEdit(
          { id: contratoSeleccionadoParaModal.id }, 
          data?.tipoPlatos || [], 
          data?.contractList || [], 
          true, 
          { id: '0' }
        )
      } catch (e: any) {
        error('Error al cargar los datos del contrato')
      } finally {
        props.setLoad(false)
      }
    } else if (!contratoSeleccionadoParaModal?.esContratoBase) {
      // Para contratos múltiples, cerrar el modal y llamar a getDataEdit
      setContratoSeleccionadoParaModal(null)
      // Los flags ya se resetearon arriba
      
      // Para contratos múltiples, llamar a getDataEdit para procesar la frecuencia
      if (props.getDataEdit && !props.bloqueado) {
        const contratoOrigenSeleccionadoStr = localStorage.getItem('contratoOrigenSeleccionado')
        const contratoBaseId = contratoOrigenSeleccionadoStr ? JSON.parse(contratoOrigenSeleccionadoStr) : null
        
        if (contratoBaseId && props.getDataEdit) {
          setTimeout(async () => {
            if (!props.getDataEdit) return
            props.setLoad(true)
            try {
              await props.getDataEdit(
                { id: contratoBaseId }, 
                data?.tipoPlatos || [], 
                data?.contractList || [], 
                true, 
                { id: '0' }
              )
            } catch (e: any) {
            } finally {
              props.setLoad(false)
            }
          }, 200)
        } else {
          localStorage.setItem('frecuenciaNecesitaActualizacion', 'true')
        }
      } else {
        localStorage.setItem('frecuenciaNecesitaActualizacion', 'true')
      }
    }
  }

  return (
    <div className='w-100'>
      <div className=''>
        <h2 className='fw-bolder text-dark'>{props.title}</h2>

        <div className='text-gray-400 fw-bold fs-6'>{props.subTitle}</div>
      </div>
      <hr></hr>
      <div className='container-box d-flex'>
        <ArrayInput classContainer='item-contract' arrayInput={arrayInput} />
        <ArrayInput classContainer='item-contract' arrayInput={arrayInput2} />
      </div>

      {/* Modal de Estructuras */}
      {showEstructurasModal && (
        <AlertModal
          show={showEstructurasModal}
          title="Estructuras del Contrato"
          showHeader={true}
          showBody={true}
          showSave={true}
          saveName="Aceptar"
          save={handleAceptarEstructuras}
          close={() => {
            // Si el usuario cancela, NO marcarlo como procesado (para poder reintentar)
            // Pero sí liberar el lock de procesamiento actual
            
            setShowEstructurasModal(false)
            setEstructurasModal([])
            setEstructurasSeleccionadas([])
            setIsLoadingContrato(false)
            abriendoModalRef.current = false
            ultimoContratoProcesadoRef.current = null
            procesandoContratoRef.current = null // CRÍTICO: Liberar el lock
          }}
          closeName="Cancelar"
          showClose={true}
          innerHTML={() => {
            const estructurasNormales = estructurasModal.filter((e: any) => !e.esEstructuraFija)
            const estructurasFijas = estructurasModal.filter((e: any) => e.esEstructuraFija)
            const todasSeleccionadas = estructurasSeleccionadas.every((e: any) => e.checked)
            const algunaSeleccionada = estructurasSeleccionadas.some((e: any) => e.checked)
            
            const handleSeleccionarTodo = () => {
              const nuevasSeleccionadas = estructurasModal.map((e: any) => ({ ...e, checked: true }))
              setEstructurasSeleccionadas(nuevasSeleccionadas)
            }
            
            const handleDeseleccionarTodo = () => {
              const nuevasSeleccionadas = estructurasModal.map((e: any) => ({ ...e, checked: false }))
              setEstructurasSeleccionadas(nuevasSeleccionadas)
            }
            
            return (
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                  <p style={{ margin: 0 }}><strong>Seleccione las estructuras que desea utilizar:</strong></p>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      type="button"
                      onClick={handleSeleccionarTodo}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: '#3498db',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 'bold'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2980b9'}
                      onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#3498db'}
                    >
                      Seleccionar Todo
                    </button>
                    <button
                      type="button"
                      onClick={handleDeseleccionarTodo}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: '#e74c3c',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 'bold'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c0392b'}
                      onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e74c3c'}
                    >
                      Deseleccionar Todo
                    </button>
                  </div>
                </div>
                {!Array.isArray(estructurasModal) || estructurasModal.length === 0 ? (
                  <p>No hay estructuras disponibles.</p>
                ) : (
                  <div style={{ maxHeight: '500px', overflowY: 'auto', marginTop: '10px' }}>
                    {/* Sección de Estructuras Normales */}
                    {estructurasNormales.length > 0 && (
                      <>
                        <div style={{ 
                          padding: '10px', 
                          backgroundColor: '#3498db', 
                          color: 'white', 
                          fontWeight: 'bold',
                          position: 'sticky',
                          top: 0,
                          zIndex: 1
                        }}>
                          📋 Estructuras ({estructurasNormales.length})
                        </div>
                        {estructurasModal.map((estructura: any, index: number) => (
                          !estructura.esEstructuraFija && (
                            <div 
                              key={index} 
                              style={{ 
                                padding: '12px', 
                                borderBottom: '1px solid #ddd',
                                backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff'
                              }}
                            >
                              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <input
                                  type="checkbox"
                                  checked={estructurasSeleccionadas[index]?.checked || false}
                                  onChange={(e) => handleEstructuraCheckbox(index, e.target.checked)}
                                  style={{ marginRight: '12px', marginTop: '4px', width: '18px', height: '18px', cursor: 'pointer', flexShrink: 0 }}
                                />
                                <div style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '8px', color: '#2c3e50' }}>
                                    {estructura.nombre || estructura.ess_nombre || estructura.structure || `Estructura ${estructura.id || estructura.ess_codigo}`}
                                  </div>
                                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px', fontSize: '12px' }}>
                                    {estructura.nombreGrupoEstructura && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Estructura Padre: </span>
                                        <span>{estructura.nombreGrupoEstructura}</span>
                                      </div>
                                    )}
                                    {estructura.cod_estructura && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Código Estructura: </span>
                                        <span>{estructura.cod_estructura}</span>
                                      </div>
                                    )}
                                    {estructura.nombreTipoPlato && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Tipo Plato: </span>
                                        <span>{estructura.nombreTipoPlato}</span>
                                      </div>
                                    )}
                                    {estructura.car_nombre_jer && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Categoría Dietética: </span>
                                        <span>{estructura.car_nombre_jer}</span>
                                      </div>
                                    )}
                                    {estructura.NombreIntolerancia && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Intolerancia: </span>
                                        <span>{estructura.NombreIntolerancia}</span>
                                      </div>
                                    )}
                                    {estructura.NombreAlergeno && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Alérgeno: </span>
                                        <span>{estructura.NombreAlergeno}</span>
                                      </div>
                                    )}
                                    {estructura.dias_bloqueados && estructura.dias_bloqueados.trim() !== '' && (
                                      <div style={{ gridColumn: '1 / -1' }}>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Días Bloqueados: </span>
                                        <span>{estructura.dias_bloqueados}</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        ))}
                      </>
                    )}
                    
                    {/* Sección de Estructuras Fijas */}
                    {estructurasFijas.length > 0 && (
                      <>
                        <div style={{ 
                          padding: '10px', 
                          backgroundColor: '#e74c3c', 
                          color: 'white', 
                          fontWeight: 'bold',
                          position: 'sticky',
                          top: 0,
                          zIndex: 1,
                          marginTop: estructurasNormales.length > 0 ? '10px' : '0'
                        }}>
                          🔒 Estructuras Fijas ({estructurasFijas.length})
                        </div>
                        {estructurasModal.map((estructura: any, index: number) => (
                          estructura.esEstructuraFija && (
                            <div 
                              key={index} 
                              style={{ 
                                padding: '12px', 
                                borderBottom: '1px solid #ddd',
                                backgroundColor: '#ffe6e6'
                              }}
                            >
                              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <input
                                  type="checkbox"
                                  checked={estructurasSeleccionadas[index]?.checked || false}
                                  onChange={(e) => handleEstructuraCheckbox(index, e.target.checked)}
                                  style={{ marginRight: '12px', marginTop: '4px', width: '18px', height: '18px', cursor: 'pointer', flexShrink: 0 }}
                                />
                                <div style={{ flex: 1 }}>
                                  <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '8px', color: '#c0392b' }}>
                                    🔒 {estructura.rec_nombre || estructura.nombre || estructura.ess_nombre || estructura.structure || `Estructura ${estructura.id || estructura.ess_codigo}`}
                                  </div>
                                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px', fontSize: '12px' }}>
                                    {estructura.nombreGrupoEstructura && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Estructura Padre: </span>
                                        <span>{estructura.nombreGrupoEstructura}</span>
                                      </div>
                                    )}
                                    {estructura.cod_estructura && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Código Estructura: </span>
                                        <span>{estructura.cod_estructura}</span>
                                      </div>
                                    )}
                                    {estructura.nombreTipoPlato && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Tipo Plato: </span>
                                        <span>{estructura.nombreTipoPlato}</span>
                                      </div>
                                    )}
                                    {estructura.car_nombre_jer && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Categoría Dietética: </span>
                                        <span>{estructura.car_nombre_jer}</span>
                                      </div>
                                    )}
                                    {estructura.NombreIntolerancia && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Intolerancia: </span>
                                        <span>{estructura.NombreIntolerancia}</span>
                                      </div>
                                    )}
                                    {estructura.NombreAlergeno && (
                                      <div>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Alérgeno: </span>
                                        <span>{estructura.NombreAlergeno}</span>
                                      </div>
                                    )}
                                    {estructura.dias_bloqueados && estructura.dias_bloqueados.trim() !== '' && (
                                      <div style={{ gridColumn: '1 / -1' }}>
                                        <span style={{ color: '#7f8c8d', fontWeight: '500' }}>Días Bloqueados: </span>
                                        <span>{estructura.dias_bloqueados}</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        ))}
                      </>
                    )}
                  </div>
                )}
              </div>
            )
          }}
        />
      )}
    </div>
  )
}
interface StepContract1Props {
  title?: string
  subTitle?: string
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void
  getDataEdit?(contrato: any, tipoPlato: any, contrsList: any, isLoad: boolean, contratoOrigen: any): void
  setIsHomologada?(value: boolean): void
  data?: {
    sitios: any[]
    regimens: any[]
    usuariosSistios: any[]
    tipoPlatos: any[]
    contractList: any[]
  }
  editData?: any
  isReady?: boolean
  formikProps?: FormikProps<any>
  setLoad?: any
  bloqueado?: boolean
}
export default React.memo(StepContract1)
